import { Component } from '@angular/core';
import { GoogleAnalyticsService } from './core/google-analytics.service';
import { StoreService } from './core/store.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(private googleAnalyticsService: GoogleAnalyticsService,
    private storeService: StoreService,
    private translate: TranslateService) {
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.googleAnalyticsService.subscribe();
  }

  ngOnDestroy() {
    this.googleAnalyticsService.unsubscribe();
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

}
